up.compiler(".up_animator_tr", function (element, data) {
  const linkto = element.querySelector(".js-linkto");
  const svgto = element.querySelector(".js-svg");
  svgto.classList.add("hidden");
  const bordering = "shadow-[inset_0_-2px_0_#23d166,inset_0_2px_0_#23d166]";
  function eraseAll() {
    const all_rows = document.querySelectorAll(".up_animator_tr");
    all_rows.forEach((e) => e.classList.remove(bordering));
    const svgtos = document.querySelectorAll(".js-svg");
    svgtos.forEach((e) => e.classList.add("hidden"));
  }

  async function onClick() {
    await up.follow(linkto);
    eraseAll();
    element.classList.add(bordering);
    svgto.classList.remove("hidden");
  }

  function initialState() {
    const elt = document.querySelector(".js-animator-detail");
    const currentSlug = elt?.dataset.slug;
    if (currentSlug === data.slug) {
      element.classList.add(bordering);
      svgto.classList.remove("hidden");
    }
  }

  initialState();

  element.addEventListener("click", onClick);
  return () => {
    element.removeEventListener("click", onClick);
  };
});
